var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "unum-field": true,
        "unum-field--no-margin": _vm.noMargin,
        "has-errors": _vm.errorBag ? _vm.errorBag.has(_vm.name) : false
      }
    },
    [
      _vm.label
        ? _c(
            "label",
            {
              class: {
                visuallyhidden: _vm.hideLabel
              },
              attrs: { for: _vm.name }
            },
            [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "disTextbox",
        staticClass: "unum-field-textbox",
        attrs: {
          type: _vm.type ? _vm.type : "text",
          autocomplete: "off",
          name: _vm.name,
          id: _vm.name,
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.updateValue()
          }
        }
      }),
      _vm._v(" "),
      _vm.helpText
        ? _c("span", { staticClass: "unum-field__help" }, [
            _vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorBag && _vm.errorBag.has(_vm.name)
        ? _c("span", { staticClass: "unum-field__help error" }, [
            _vm._v("\n    " + _vm._s(_vm.errorBag.first(_vm.name)) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b0cc173", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0cc173","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Textbox.vue
// module id = null
// module chunks = 